import { PackageSubLOBProps } from "components/flexComponents/WizardPackagePWA/typings";
import * as React from "react";
import { observer } from "mobx-react";
import { Location } from "src/components/shared/Location/Location";
import { Dates } from "src/components/shared/Dates/Dates";
import { PackagePartialStay } from "components/flexComponents/WizardPackagePWA/components/PackagePartialStay";
import { StaySomewhereElseToggle } from "components/flexComponents/WizardPackagePWA/components/StaySomewhereElseToggle";
import { StaySomewhereElse } from "components/flexComponents/WizardPackagePWA/components/StaySomewhereElse";
import { Experiment, isVariantEnabled } from "components/utility/experiment";
import {
  UitkLayoutConditionalGridSpan,
  UitkLayoutGrid,
  UitkLayoutGridItem,
  UitkLayoutConditionalGridColumnRow,
} from "uitk-react-layout-grid";
import { Viewport, ViewSmall, ViewMedium } from "@shared-ui/viewport-context";

export const FlightHotelDefault = observer((props: PackageSubLOBProps) => {
  const locationColSpan: UitkLayoutConditionalGridSpan = { small: 2, large: 8 };
  const datesColSpan: UitkLayoutConditionalGridSpan = { small: 2, large: 4 };
  const datesPartialStayColSpan: UitkLayoutConditionalGridSpan = { small: 2, large: 12 };
  const mainGridColumns: UitkLayoutConditionalGridColumnRow = { small: 2, large: 12 };
  const staySomewhereElseColSpan: UitkLayoutConditionalGridSpan = { small: 2, large: 4 };
  const packagePartialStayColSpan: UitkLayoutConditionalGridSpan = { small: 2, large: 8 };

  const isStaySomewhereElseEnabled =
    isVariantEnabled(props.context, Experiment.MIT_PWASF_PKGFLEXIBILITY_FSSSE) && props.packageWizardState.isDesktop;

  const { isFlightHotelDefaultFormValid, updateInvalidFormsState } = props.packageWizardState;

  if (isFlightHotelDefaultFormValid) {
    updateInvalidFormsState();
  }

  function renderDefault() {
    return (
      <>
        <UitkLayoutGrid columns={mainGridColumns} space="three">
          <Location
            originField={true}
            destinationField={true}
            lobState={props.packageWizardState}
            colSpan={locationColSpan}
            setInputsRefs={props.setInputsRefs}
            showSwapLocationsControl={true}
          />
          <Dates lobState={props.packageWizardState} colSpan={datesColSpan} setInputsRefs={props.setInputsRefs} />
        </UitkLayoutGrid>
      </>
    );
  }

  return (
    <>
      {renderDefault()}
      <div className="all-t-margin-three">
        <UitkLayoutGrid columns={mainGridColumns} space="three">
          {isStaySomewhereElseEnabled && (
            <UitkLayoutGridItem colSpan={staySomewhereElseColSpan}>
              <div>
                <UitkLayoutGrid columns={mainGridColumns}>
                  <StaySomewhereElseToggle
                    toggleStaySomewhereElse={props.toggleStaySomewhereElse}
                    packageWizardState={props.packageWizardState}
                  />
                  {props.packageWizardState.staySomewhereElse && (
                    <StaySomewhereElse lobState={props.packageWizardState} colSpan={mainGridColumns} />
                  )}
                </UitkLayoutGrid>
              </div>
            </UitkLayoutGridItem>
          )}

          <UitkLayoutGridItem colSpan={packagePartialStayColSpan}>
            <div>
              <UitkLayoutGrid columns={mainGridColumns} className="s-b-padding-three">
                <PackagePartialStay
                  togglePartialStay={props.togglePartialStay}
                  packageWizardState={props.packageWizardState}
                />
                {props.packageWizardState.isPartialStay() && (
                  <Viewport>
                    <ViewSmall>
                      <Dates
                        lobState={props.packageWizardState}
                        isPartialStay={true}
                        colSpan={datesPartialStayColSpan}
                        startId="d1-partial"
                        endId="d2-partial"
                        stackedDates={true}
                        setInputsRefs={props.setInputsRefs}
                      />
                    </ViewSmall>
                    <ViewMedium>
                      <Dates
                        lobState={props.packageWizardState}
                        isPartialStay={true}
                        colSpan={datesPartialStayColSpan}
                        startId="d1-partial"
                        endId="d2-partial"
                        setInputsRefs={props.setInputsRefs}
                      />
                    </ViewMedium>
                  </Viewport>
                )}
              </UitkLayoutGrid>
            </div>
          </UitkLayoutGridItem>
        </UitkLayoutGrid>
      </div>
    </>
  );
});
